import { SimpleDocCommand } from '../../apps/DocsApp/commands/v5/types';
import { StandardToolResult } from '../../types/standardToolResults';
import { CommandExecutionContext } from '../../types/commands';

export const entity_open: SimpleDocCommand = {
  id: 'entity_open',
  logicalName: 'entity_open',
  version: 'v2',

  description: 'Open an entity as the active visible window for the user.',

  schema: {
    parameters: [
      {
        name: 'entityId',
        type: 'string',
        description: 'The entity ID to open (doc_*, note_*, canvas_*, sheet_*, pdf_*, file_*, presentation_*, bookproject_*, etc.)',
        required: true
      }
    ]
  },

  handler: async (params: any, _context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { entityId } = params;
    const { useCommandRegistryStore } = await import('../../stores/commandRegistryStore');
    const { executeCommand } = useCommandRegistryStore.getState();
    return await executeCommand('space_open_window', { entityId }) as StandardToolResult;
  }
};
